module.exports = "/_next/static/images/bucuresti-2d8eacc5a106a2e88c4c76a475f5e599.jpg.webp";